<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 穴位维护
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">							
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">								
								<el-input placeholder="请输入关键字查询" class="longInput" v-model="searchData.name"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>
							<el-table-column align="center" label="穴位名" prop="name">
							</el-table-column>
							
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增穴位维护' : '编辑穴位维护'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item label="穴位" prop="name">
									<el-input class="longInput" v-model="addUserForm.name"></el-input>
								</el-form-item>
								<el-form-item label="穴位位置" prop="acupointPosition">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" class="longInput"
										v-model="addUserForm.acupointPosition"></el-input>
								</el-form-item>
								<el-form-item label="所属经络" prop="meridians">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" class="longInput"
										v-model="addUserForm.meridians"></el-input>
								</el-form-item>
								<el-form-item label="方法" prop="acupointOperation">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" class="longInput"
										v-model="addUserForm.acupointOperation"></el-input>
								</el-form-item>
								<el-form-item label="功效" prop="efficacy">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" class="longInput"
										v-model="addUserForm.efficacy"></el-input>
								</el-form-item>
								<el-form-item label="图片" prop="pic">
									<el-autocomplete  popper-class="my-autocomplete" v-model="addUserForm.pic"
										:fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
										<template #prefix>
										    <el-icon class="el-input__icon"><Search></Search></el-icon>
										</template>
										<template #default="{item}">
											<div class="img">
												<img :src="globalImageUrl + item.path" />
												<span class="name">{{ item.name }}</span>
											</div>
										</template>
									</el-autocomplete>
									<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
								</el-form-item>
								<div class="select" v-if="selectedPicList.length > 0">
									<ul class="select-ul">
										<li v-for="(item, index) in selectedPicList" :key="index">
											<div class="path">
												<img :src="globalImageUrl + item.path" />
											</div>
											<span class="name">{{ item.name }}</span>
										</li>
									</ul>
									<ul class="selected-ul">
										<span class="span">已选择的图片：</span>
										<div class="li">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<span class="name">{{ item.name }}</span>
												<i @click="handleClose(item)" class="el-icon-circle-close">
													<CircleClose style="width:14px;float: left;margin-top: 8px;"></CircleClose>
												</i>
											</li>
										</div>
									</ul>
								</div>

								<el-form-item class="el-form-item-line" label="视频" prop="video">
									<el-select @change="selectVideo" filterable v-model="addUserForm.videoId"
										placeholder="请选择视频">
										<el-option v-for="item in videoList" :key="item.title" :label="item.title"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<div class="select" v-if="selectVideoList.length > 0">
									<ul class="selected-ul">
										<span class="span">已选择的视频：</span>
										<div class="li">
											<li v-for="(item, index) in selectVideoList" :key="index">
												<span class="name">{{ item.title }}</span>
												<i @click="handleVideoClose(item)" class="el-icon-circle-close"></i>
											</li>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	import { RefreshRight,Search } from '@element-plus/icons-vue'
	export default {
		data() {
			return {
				RefreshRight,
				Search,
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
						name: "选项维护",
					},
					{
						id: 3,
						name: "健康评估",
					},
					{
						id: 4,
						name: "穴位维护",
					},
					{
						id: 5,
						name: "运动健康",
					},
					{
						id: 6,
						name: "药食管理",
					},
					{
						id: 7,
						name: "图片管理",
					},
					{
						id: 8,
						name: "视频管理",
					},
				],
				currentTabIndex: 4,
				searchData: {
					name:''
				},
				fileData: null, //文件
				fileList: [],
				fileObj: null,
				tableListData: [],
				pulseList: [],
				addUserForm: {
					name: "",
					acupointPosition: "", //位置
					meridians: "",
					acupointOperation: "",
					efficacy: "", //功效
					pic: "", //选择的图片
					videoId: "",
					id: "",
				},
				rules: {

					name: [{
						required: true,
						message: "请输入穴位名称",
						trigger: "blur",
					}, ]
					
				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				picList: [],
				selectedPicList: [], //被选中的图片
				isAcupointFlag: false, //是否为穴位
				isChineseMedicineFlag: false, //是否为中成药
				typeList: [{
						label: "艾灸",
						id: "0",
					},
					{
						label: "刮痧",
						id: "1",
					},
					{
						label: "拔罐",
						id: "2",
					},
				],
				bodyList: [{
						label: "心",
						id: "0",
					},
					{
						label: "肝",
						id: "1",
					},
					{
						label: "脾",
						id: "2",
					},
					{
						label: "肺",
						id: "3",
					},
					{
						label: "肾",
						id: "4",
					},
				],
				pulseRateList: [{
						label: "数",
						id: "0",
					},
					{
						label: "正常",
						id: "1",
					},
					{
						label: "迟",
						id: "2",
					},
				],
				posList: [{
						label: "有力",
						id: "0",
					},
					{
						label: "正常",
						id: "1",
					},
					{
						label: "无力",
						id: "2",
					},
				],
				videoList: [],
				selectVideoList: [],
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
			},
			//重置
			reset() {
				this.searchData = {
					name:''
				}
				this.searchPluse();
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.name = "";
				this.addUserForm.acupointPosition = "";
				this.addUserForm.meridians = "";
				this.addUserForm.acupointOperation = "";
				this.addUserForm.efficacy = "";
				this.addUserForm.pic = "";
				this.addUserForm.videoId = "";
				this.addUserForm.id = "";
				this.selectedPicList = [];
				this.selectVideoList = [];
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//编辑脉象
			edit(item) {
				this.addOrEdit = "edit";
				this.getDetail(item.id);
			},
			//获取详情
			getDetail(id) {
				this.$applicationJson("/business/base/acupoint/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name = item.name;
							this.addUserForm.acupointPosition = item.position;
							this.addUserForm.meridians = item.belong;
							this.addUserForm.acupointOperation = item.operation;
							this.addUserForm.efficacy = item.effect;
							this.addUserForm.id = item.id;
							this.addUserForm.pic = "";
							if (item.images) {
								this.selectedPicList = item.images;
							}
							if (item.videos) {
								if (item.videos.length > 0) {
									this.addUserForm.videoId = item.videos[0].id;
									this.selectVideoList = item.videos;
								}
							}
							this.addUserFlag = true;
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						this.delUserInfo(item.id);
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getPlanList(this.currentPage);
			},
			//确定
			addPatient(formName) {
				//this.$forceUpdate();
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add") {
							this.addUserInfo();
						}
						if (this.addOrEdit == "edit") {
							this.editUserInfo();
						}
					} else {
						return false;
					}
				});
			},
			//新增
			addUserInfo() {

				this.$applicationJson("/business/base/acupoint/add", {
						name: this.addUserForm.name,
						position: this.addUserForm.acupointPosition,
						belong: this.addUserForm.meridians,
						operation: this.addUserForm.acupointOperation,
						effect: this.addUserForm.efficacy,
						id: "",
						images: this.selectedPicList,
						videos: this.selectVideoList,
						type:'穴位'
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(this.currentPage);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑
			editUserInfo() {
				this.$applicationJson("/business/base/acupoint/edit", {
						name: this.addUserForm.name,
						position: this.addUserForm.acupointPosition,
						belong: this.addUserForm.meridians,
						operation: this.addUserForm.acupointOperation,
						effect: this.addUserForm.efficacy,
						id: this.addUserForm.id,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						type:'穴位'
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(this.currentPage);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除
			delUserInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/acupoint/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.getPlanList(this.currentPage);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//搜索
			searchPluse() {
				this.getPlanList(0);
				this.currentPage = 0;
			},
			//获取脉象列表
			getPlanList(currentPage) {
				this.$applicationJson("/business/base/acupoint/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//选择视频
			selectVideo(id) {
				this.selectVideoList = [];
				for (let i = 0; i < this.videoList.length; i++) {
					if (this.videoList[i].id == id) {
						this.selectVideoList.push(this.videoList[i]);
					}
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			//视频关闭
			handleVideoClose(tag) {
				this.addUserForm.videoId = "";
				this.selectVideoList.splice(this.selectVideoList.indexOf(tag), 1);
			},
			//搜索切换类型
			changeType(val) {
				this.getPlanList(0);
				this.currentPage = 0;
			},
			//切换
			changeBodyPart() {
				this.getPlanList(0);
				this.currentPage = 0;
			},
			//获取视频列表
			getVideoList(page) {
				this.$applicationJson("/business/shutcm/video/paging", {
						orderBy: null,
						orderType: 1, //0正序  1倒序
						page: 0,
						pageSize: 100,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.videoList = res.data.data.records;
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//改变类型
			changeScrapping(val) {},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getImageList(0);
				this.getPlanList(0);
				this.getVideoList();
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 60px;
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 220px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}
		}
	}

	.dialog {
		:deep(.el-dialog__body){
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.line-item {
							.el-form-item {
								width: 50%;
							}
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
